import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=d447d5ca&scoped=true"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=d447d5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d447d5ca",
  null
  
)

export default component.exports